import {PageId} from "./PageId";
import {homeEpics} from "../../Home/HomeEpics";
import {ShowPageActions} from "./ShowPageActions";
import {
    AsyncAccountComponent,
    AsyncChangeEmailComponent,
    AsyncChangePasswordComponent,
    AsyncChangePhoneNumberComponent,
    AsyncContactComponent,
    AsyncCreateSouscriptionComponent,
    AsyncEnrollmentComponent,
    AsyncHomeComponent,
    AsyncLoginComponent,
    AsyncPressComponent,
    AsyncRenewPasswordComponent,
    AsyncResetPasswordComponent,
    AsyncSouscriptionSuiviComponent,
    AsyncStartEnrolmmentComponent,
    AsyncSuiviVentesComponent
} from "./AsyncPageComponents";
import {home} from "../../Home/HomeReducers";
import {buildNoTokenRoute, buildRoute, buildShowEpic, buildURLAction, PageDefinition} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../../services/ui/PledgerPageComponentState";
import {enrollment} from "../../Enrollment/EnrollmentReducers";
import {enrollmentEpics} from "../../Enrollment/EnrollmentEpics";
import {login} from "../../Login/LoginReducers";
import {loginEpics} from "../../Login/LoginEpics";
import {resetPassword} from "../../ResetPassword/ResetPasswordReducers";
import {resetPasswordEpics} from "../../ResetPassword/ResetPasswordEpics";
import {renewPassword} from "../../RenewPassword/RenewPasswordReducers";
import {renewPasswordEpics} from "../../RenewPassword/RenewPasswordEpics";
import {contact} from "../../Contact/ContactReducers";
import {contactEpics} from "../../Contact/ContactEpics";
import {pressEpics} from "../../Press/PressEpics";
import {press} from "../../Press/PressReducers";
import {accountEpics} from "../../Account/AccountEpics";
import {account} from "../../Account/AccountReducers";

import {startEnrollment} from "../../StartEnrollment/StartEnrollmentReducers";
import {startEnrollmentEpics} from "../../StartEnrollment/StartEnrollmentEpics";
import {changePassword} from "../../ChangePassword/ChangePasswordReducers";
import {changePasswordEpics} from "../../ChangePassword/ChangePasswordEpics";
import {changeEmail} from "../../ChangeEmail/ChangeEmailReducers";
import {changeEmailEpics} from "../../ChangeEmail/ChangeEmailEpics";
import {changePhoneNumber} from "../../ChangePhoneNumber/ChangePhoneNumberReducers";
import {changePhoneNumberEpics} from "../../ChangePhoneNumber/ChangePhoneNumberEpics";
import {createSouscriptionEpics} from "../../CreateSouscription/CreateSouscriptionEpics";
import {createSouscription} from "../../CreateSouscription/CreateSouscriptionReducers";
import {suiviVentes} from "../../SuiviVentes/SuiviVentesReducers";
import {suiviVentesEpics} from "../../SuiviVentes/SuiviVentesEpics";
import {souscriptionSuivi} from "../../SouscriptionSuivi/SouscriptionSuiviReducers";
import {souscriptionSuiviEpics} from "../../SouscriptionSuivi/SouscriptionSuiviEpics";


// par ordre de résolution d'URL : d'abord avec paramètre, puis sans
export const pageDefinitions  : PageDefinition<PageId,PledgerPageComponentState>[] = [
    {
        pageId:PageId.HOME_PAGE_ID,
        showAction:ShowPageActions.SHOW_HOME_ACTION,
        recreateAction:ShowPageActions.RECREATE_HOME_ACTION,
        reducers: home,
        epics:homeEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/home",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/home',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncHomeComponent,routePath:"/home",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.ENROLLMENT_PAGE_ID,
        showAction:ShowPageActions.SHOW_ENROLLMENT_ACTION,
        recreateAction:ShowPageActions.RECREATE_ENROLLMENT_ACTION,
        reducers: enrollment,
        epics: enrollmentEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/enrollment",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/enrollment',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncEnrollmentComponent,routePath:"/enrollment",pageComponentBuilder:buildNoTokenRoute }, // buildEnrollmentRoute
    },
    {
        pageId:PageId.LOGIN_PAGE_ID,
        showAction:ShowPageActions.SHOW_LOGIN_ACTION,
        recreateAction:ShowPageActions.RECREATE_LOGIN_ACTION,
        reducers: login,
        epics: loginEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/login",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/login',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncLoginComponent,routePath:"/login",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.RESET_PASSWORD_PAGE_ID,
        showAction:ShowPageActions.SHOW_RESET_PASSWORD_ACTION,
        recreateAction:ShowPageActions.RECREATE_RESET_PASSWORD_ACTION,
        reducers: resetPassword,
        epics: resetPasswordEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/resetPassword",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/resetPassword',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncResetPasswordComponent,routePath:"/resetPassword",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.RENEW_PASSWORD_PAGE_ID,
        showAction:ShowPageActions.SHOW_RENEW_PASSWORD_ACTION,
        recreateAction:ShowPageActions.RECREATE_RENEW_PASSWORD_ACTION,
        reducers: renewPassword,
        epics: renewPasswordEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/renewPassword",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/renewPassword',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncRenewPasswordComponent,routePath:"/renewPassword",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.CONTACT_PAGE_ID,
        showAction:ShowPageActions.SHOW_CONTACT_ACTION,
        recreateAction:ShowPageActions.RECREATE_CONTACT_ACTION,
        reducers: contact,
        epics: contactEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/contact",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/contact',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncContactComponent,routePath:"/contact",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.PRESS_PAGE_ID,
        showAction:ShowPageActions.SHOW_PRESS_ACTION,
        recreateAction:ShowPageActions.RECREATE_PRESS_ACTION,
        reducers: press,
        epics: pressEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/press",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/press',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncPressComponent,routePath:"/press",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.ACCOUNT_PAGE_ID,
        showAction:ShowPageActions.SHOW_ACCOUNT_ACTION,
        recreateAction:ShowPageActions.RECREATE_ACCOUNT_ACTION,
        reducers: account,
        epics: accountEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/account",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/account',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncAccountComponent,routePath:"/account",pageComponentBuilder: buildRoute },
    },
    {
        pageId:PageId.START_ENROLLMENT_PAGE_ID,
        showAction:ShowPageActions.SHOW_START_ENROLLMENT_ACTION,
        recreateAction:ShowPageActions.RECREATE_START_ENROLLMENT_ACTION,
        reducers: startEnrollment,
        epics: startEnrollmentEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/startEnrollment",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/startEnrollment',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncStartEnrolmmentComponent,routePath:"/startEnrollment",pageComponentBuilder:buildNoTokenRoute },
    },
    {
        pageId:PageId.CHANGE_PASSWORD_PAGE_ID,
        showAction:ShowPageActions.SHOW_CHANGE_PASSWORD_ACTION,
        recreateAction:ShowPageActions.RECREATE_CHANGE_PASSWORD_ACTION,
        reducers: changePassword,
        epics: changePasswordEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/changePassword",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/changePassword',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncChangePasswordComponent,routePath:"/changePassword",pageComponentBuilder:buildRoute },
    },
    {
        pageId:PageId.CHANGE_EMAIL_PAGE_ID,
        showAction:ShowPageActions.SHOW_CHANGE_EMAIL_ACTION,
        recreateAction:ShowPageActions.RECREATE_CHANGE_EMAIL_ACTION,
        reducers: changeEmail,
        epics: changeEmailEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/changeEmail",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/changeEmail',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncChangeEmailComponent,routePath:"/changeEmail",pageComponentBuilder:buildRoute },
    },
    {
        pageId:PageId.CHANGE_PHONE_NUMBER_PAGE_ID,
        showAction:ShowPageActions.SHOW_CHANGE_PHONE_NUMBER_ACTION,
        recreateAction:ShowPageActions.RECREATE_CHANGE_PHONE_NUMBER_ACTION,
        reducers: changePhoneNumber,
        epics: changePhoneNumberEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/changePhoneNumber",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/changePhoneNumber',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncChangePhoneNumberComponent,routePath:"/changePhoneNumber",pageComponentBuilder:buildRoute },
    },
    {
        pageId:PageId.CREATE_SOUSCRIPTION_PAGE_ID,
        showAction:ShowPageActions.SHOW_CREATE_SOUSCRIPTION_ACTION,
        recreateAction:ShowPageActions.RECREATE_CREATE_SOUSCRIPTION_ACTION,
        reducers: createSouscription,
        epics: createSouscriptionEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/createSouscription",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/createSouscription',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncCreateSouscriptionComponent,routePath:"/createSouscription",pageComponentBuilder:buildRoute },
    },
    {
        pageId:PageId.SUIVI_VENTES_PAGE_ID,
        showAction:ShowPageActions.SHOW_SUIVI_VENTES_ACTION,
        recreateAction:ShowPageActions.RECREATE_SUIVI_VENTES_ACTION,
        reducers: suiviVentes,
        epics: suiviVentesEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/suiviVentes",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/suiviVentes',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncSuiviVentesComponent,routePath:"/suiviVentes",pageComponentBuilder:buildRoute },
    },
    {
        pageId:PageId.SOUSCRIPTION_SUIVI_PAGE_ID,
        showAction:ShowPageActions.SHOW_SOUSCRIPTION_SUIVI_ACTION,
        recreateAction:ShowPageActions.RECREATE_SOUSCRIPTION_SUIVI_ACTION,
        reducers: souscriptionSuivi,
        epics: souscriptionSuiviEpics,
        backgroundColor:'transparent',
        urlActionMapping: [
            { hashURLPrefix:"/suiviVente",replace:false, actionBuilder: buildURLAction }
        ],
        showEpic : { showEpicURL:'/suiviVente',epicBuilder:buildShowEpic },
        routeDefinition : { pageComponent:AsyncSouscriptionSuiviComponent,routePath:"/suiviVente",pageComponentBuilder:buildRoute },
    }
];
